import TensorIcon from '@assets/TensorIcon'
import MagicEdenIcon from '@assets/magicEdenIcon.png'
import { ShoppingBag } from 'lucide-react'
import Image from 'next/image'
import { FocusEvent, KeyboardEvent, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function BuyDropdown() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const toggleHandler = useCallback(() => setOpen((prev) => !prev), [open])

  const blurHandler = useCallback(
    (event: FocusEvent<HTMLDivElement, Element>) => {
      switch (event?.relatedTarget?.id) {
        case 'dropdown-list':
        case 'dropdown-item':
        case 'dropdown-link':
          return
        default:
          setOpen(false)
      }
    },
    [],
  )

  const keyDownHandler = useCallback((event: KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Escape') setOpen(false)
  }, [])

  const buyLinks = [
    {
      name: t('components.buyDropdown.magicEden'),
      href: 'https://magiceden.io/marketplace/dewi',
      icon: (
        <Image alt="magic-eden" width="26" height="26" src={MagicEdenIcon} />
      ),
    },
    {
      name: t('components.buyDropdown.tensor'),
      href: 'https://www.tensor.trade/trade/dewi',
      icon: <TensorIcon />,
    },
  ]

  return (
    <div
      onKeyDown={keyDownHandler}
      onBlur={blurHandler}
      className="text-[white] relative flex justify-start mui-lg:justify-center"
    >
      <button
        className="flex items-center gap-1.5 h-full text-[white] relative overflow-hidden w-full transition"
        onClick={toggleHandler}
      >
        <ShoppingBag size={18} strokeWidth={1.75} />
        <p className="font-display uppercase tracking-[0.02em]">
          {t('components.buyDropdown.buy')}
        </p>
      </button>
      <ul
        id="dropdown-list"
        className={`absolute top-10 mui-lg:top-11 w-[12rem] mui-lg:w-[10rem] text-sm bg-dark-8 p-2 flex flex-col gap-3 rounded-card transition z-10 ${!open ? 'opacity-0 pointer-events-none' : 'opacity-1'}`}
      >
        {buyLinks.map(({ name, href, icon }) => (
          <li id="dropdown-item" key={name}>
            <a
              id="dropdown-link"
              className="flex gap-3 items-center transition p-3 rounded-md hover:bg-dark-6 hover:opacity-80 active:opacity-80 active:bg-dark-5"
              target="_blank"
              href={href}
            >
              <span>{icon}</span>
              <p>{name}</p>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
